export class EntitlementRepositoryValidationError extends Error {
  constructor(
    message: string,
    public readonly data: unknown
  ) {
    super(message)
    this.name = 'ValidationError'
  }
}
